import HeaderLayout from 'components/HeaderLayout/HeaderLayout';
import AuthView from 'views/AuthView/AuthView';

const DetailsTop = () => {
  return <HeaderLayout right={<AuthView />} />;
};

export default DetailsTop;
